import { Routes } from '@angular/router';
import { authGuard, loginRedirectGuard, superAdminGuard } from './core/guards/auth.guard';

export const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'dashboard' },
  {
    path: 'login',
    canActivate: [loginRedirectGuard],
    loadComponent: () => import('./features/login/login.component').then((m) => m.LoginComponent),
  },
  {
    path: 'accept-invite',
    loadComponent: () =>
      import('./features/accept-invite/accept-invite.component').then((m) => m.AcceptInviteComponent),
  },
  {
    path: 'dashboard',
    canActivate: [authGuard],
    loadComponent: () => import('./features/dashboard/dashboard.component').then((m) => m.DashboardComponent),
  },
  {
    path: 'companies',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/companies/companies.component').then((m) => m.CompaniesComponent),
  },
  {
    path: 'companies/:companyId',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/companies/company-details/company-details.component').then(
        (m) => m.CompanyDetailsComponent,
      ),
  },
  {
    path: 'plans',
    canActivate: [authGuard],
    loadComponent: () => import('./features/plans/plans.component').then((m) => m.PlansComponent),
  },
  {
    path: 'app-releases',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/app-releases/app-releases.component').then((m) => m.AppReleasesComponent),
  },
  {
    path: 'console-admins',
    canActivate: [superAdminGuard],
    loadComponent: () =>
      import('./features/console-admins/console-admins.component').then((m) => m.ConsoleAdminsComponent),
  },
  {
    path: 'audit-log',
    canActivate: [superAdminGuard],
    loadComponent: () => import('./features/audit-log/audit-log.component').then((m) => m.AuditLogComponent),
  },
  { path: '**', redirectTo: 'dashboard' },
];
